import { RouteProp, useNavigation, useRoute } from '../../../navigation/native';
import React from 'react';
import styled from '../../../components/styled';
import Icon from '../../../components/Icon';

import { RootStackParamList } from '../../../app/Navigation';
import { Route } from '../../../app/Route';
import { editingActions, selectShiftLogDetails } from '../../../store';
import { findGroupSnippet } from '../helpers';
import Layout from '../Layout';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import RollupDetailsCard from '../RollupDetailsCard';

const RollupScreen = () => {
  const navigation = useNavigation();
  const { params } = useRoute<RouteProp<RootStackParamList, 'EditingRollupScreen'>>();
  const dispatch = useDispatch<AppDispatch>();

  const shiftLogDetails = selectShiftLogDetails.useHook();

  const [, snippet] = findGroupSnippet(params, shiftLogDetails.snippets);

  const handleLinkPressed = (index: number) => {
    dispatch(editingActions.editedSnippetChanged(snippet));
    navigation.navigate(Route.editingRowListScreen, {
      ...params,
      rollupIndex: index,
    });
  };

  return (
    <Layout
      title={params.lastLink}
      header={<></>}
      content={
        <>
          {snippet.data.map((rollup, index) => (
            <RollupContainer key={index} onPress={() => handleLinkPressed(index)}>
              <RollupDetailsCardWrapper>
                <RollupDetailsCard rollupDetails={rollup.rollupDetails} />
              </RollupDetailsCardWrapper>
              <NextIcon name="navigate-next" size={20} />
            </RollupContainer>
          ))}
        </>
      }
    />
  );
};

export default RollupScreen;

const RollupContainer = styled.TouchableOpacity`
  flex-direction: row !important;
  background: white;
  margin-top: 10px;
  align-items: center;
  border-radius: 4px;
`;

const RollupDetailsCardWrapper = styled.View`
  flex: 1;
`;

const NextIcon = styled(Icon)`
  margin-right: 10px;
`;
